<template>
  <div class="projectList_content">
    <el-card class="project_card">
      <badeg
        v-if="isStatus"
        :text="
          source.auditState === 1 && (source.useState !== 1)? '未使用':
          source.auditState === 1 && source.useState === 1? '已使用':
          source.auditState === 0? '审核中':
          source.auditState === 2? '审核拒绝': '暂无状态'
          "
      />
      <div slot="header">
        <div class="project_card-header">
          <div class="project_card-header-left">
            <span>{{ source.subjectName }}</span>
            <div class="project_price" v-if="source.packageType === 1">
              <div>
                套餐价:<span>{{ source.price }}</span>
              </div>
              <div>
                协议价:<span>{{ source.originPrice }}</span>
              </div>
            </div>
          </div>
          <div class="project_card-header-right">
            <div v-if="isStatus">
              <el-button
                @click="handleModifyState(source)"
                type="primary"
                size="mini"
                v-if="
                  source.auditState === 1 &&
                  (source.useState === 0 || source.useState === 2)
                "
                >确认使用</el-button
              >
              <el-button
                @click="handleModifyState(source)"
                size="mini"
                v-if="source.auditState === 1 && source.useState === 1"
                >取消使用</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <el-card
        class="project_content"
        v-for="item in source.contents"
        :key="item.contentId"
      >
        <div
          class="project_content_subTitle"
          v-if="source.packageType === 1"
        >
          {{ item.contentName || item.packageName }}
        </div>
        <shop-card
          :data="source.packageType === 2 ? [item] : item.contents"
          :packageType="source.packageType"
        ></shop-card>
        <div
          v-if="item.laborCost && source.packageType === 1"
          class="tip-right"
        >
          额外工时费用:(单位：{{ item.laborCost.specValue
          }}{{ item.laborCost.specUnit }}；单价：{{
            item.laborCost.laborCost
          }}元；数量：X{{ item.laborCost.num }})
        </div>
      </el-card>
      <slot name="footer"></slot>
    </el-card>
  </div>
</template>

<!-- -->
<script>
import badeg from '@/components/badge/index.vue'
import ShopCard from './shopCard.vue'

export default {
  name: 'projectList',
  components: {
    badeg,
    ShopCard,
  },
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
    isStatus: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleModifyState(source) {
      this.$emit('modifyStoreUseState', source)
    },
  },
}
</script>


<style lang="scss" scoped>
.projectList_content {
  margin-bottom: 20px;
}
.project_card {
  position: relative;
}
.project_card-header {
  display: flex;
  justify-content: space-between;
  padding-right: 60px;
}

.project_price {
  display: flex;
  font-size: 12px;
  color: #666;
  margin-top: 10px;
  & > div {
    margin-right: 20px;
  }
}

.project_content {
  margin-bottom: 20px;
  .project_content_subTitle {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .tip-right {
    text-align: right;
    margin-top: 20px;
    font-weight: 500;
    font-size: 14px;
  }
}
</style>
